// extracted by mini-css-extract-plugin
export default {"panelHeading":"LpPanelHeading_panelHeading__dud4L","activePanel":"LpPanelHeading_activePanel__HoL61"};